<template>
  <div class="container">
    <div class="mt-11 flex w-full">
      <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/4 mx-auto text-center">
        <img src="@/assets/images/pages/success.svg" alt="Success" width="465" class="mx-auto mb-4 max-w-full">
        <h1 class="sm:mx-0 mt-5 mb-10 text-5xl d-theme-heading-color">¡Has enviado tu documento!</h1>
        <h4 v-if="toSign" class="sm:mx-0 mx-2 sm:mb-10 font-w-400">
          Puedes firmar tu documento con el siguiente botón
        </h4>
        <div class="vx-row">
          <vs-button v-if="toSign" size="large" :to="urlToSign" class="float-left mr-10">Firmar ahora</vs-button>
          <vs-button size="large" to="/" class="float-right" type="border">Mis documentos</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "purchaseSuccess",
  props: ['toSign', 'url'],
  computed: {
    getPlanName() {
      return this.$store.state.account.user.me.plan.name;
    },
    urlToSign() {
      return "/sign-document/" + this.url
    }
  }
}
</script>


<style scoped>
.mt-11{
  margin-top: 6.5em!important;
}

</style>
